import React, { createContext, useContext, useState } from "react";

const StateContext = createContext();

export const ThemeContext = ({ children }) => {
  const [screenSize, setScreenSize] = useState(null);
  const [activeMainPageNav, setActiveMainPageNav] = useState(null);
  const [activeAppearancePageNav, setActiveAppearancePageNav] = useState(null);

  const [activeInvitionSystemPageNav, setActiveInvitionSystemPageNav] =
    useState(null);
  const [activeUpgradeAnalyticsPageNav, setActiveUpgradeAnalyticsPageNav] =
    useState(null);

  const [activeSettingPageNav, setActiveSettingPageNav] = useState(null);

  const [activeSettingSubNav, setActiveSettingSubNav] = useState(null);

  const [activeMenu, setActiveMenu] = useState(true);
  const [activeLang, setActiveLang] = useState("en");
  const [activeDir, setActiveDir] = useState("ltr");

  const [isAddBlockTab, setisAddBlockTab] = useState(true);

  return (
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    <StateContext.Provider
      value={{
        activeMenu,
        screenSize,
        setScreenSize,
        setActiveMenu,
        activeMainPageNav,
        setActiveMainPageNav,
        activeAppearancePageNav,
        activeUpgradeAnalyticsPageNav,
        setActiveAppearancePageNav,
        activeSettingPageNav,
        setActiveSettingPageNav,
        activeInvitionSystemPageNav,
        setActiveInvitionSystemPageNav,
        setActiveUpgradeAnalyticsPageNav,
        activeSettingSubNav,
        setActiveSettingSubNav,
        activeLang,
        setActiveLang,
        activeDir,
        setActiveDir,
        isAddBlockTab,
        setisAddBlockTab,
      }}
    >
      {children}
    </StateContext.Provider>
  );
};

export const useStateContext = () => useContext(StateContext);
